import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

interface OwnProps {
	material: { materialId: number; displayName: string; };
	onRateHistory(material: { materialId: number; displayName: string; }): void;
}

type Props = OwnProps;

const MaterialRateHistoryButton: React.FC<Props> = (props) => {
	const {
		material,
		onRateHistory: onPreview,
	} = props;

	const handlePreview = React.useCallback(() => onPreview(material), [material, onPreview]);

	return (
		<Button
			label="Rate History"
			onClick={handlePreview}
			style="link"
		/>
	);
};

export default MaterialRateHistoryButton;
